import React, { Component } from 'react';
import TheRiverCard from './TheRiverCard';
import TheRiverIndicator from './TheRiverIndicator';

const BURNING_ID = 18;

export default class TheRiverItem extends Component {

    constructor(props) {
        super(props);
        this.tradelaneIndex = props.tradelaneIndex;
        this.currentCardId = props.tradelaneData.id;
        this.cardComponent = null;
        this.indicatorComponent = null;
        // Pre-bound for the same reason as TheRiver's tradelane refs: an
        // inline-arrow ref here churned this.indicatorComponent to null
        // during commit, so even a highlight that reached this item via a
        // valid TheRiver ref would have hit a null indicator and silently
        // no-op'd through `this.indicatorComponent && ...`.
        this.setIndicatorRef = (ref) => { this.indicatorComponent = ref; };
        this.setCardRef = (ref) => { this.cardComponent = ref; };
    }

    // update due to gameplayer update.

    onClick = () => {
        this.props.onClick(this.tradelaneIndex);
    };

    highlight = () => {
        this.indicatorComponent && this.indicatorComponent.highlight();
    };

    showDiscard = () => {
        this.indicatorComponent && this.indicatorComponent.showDiscard();
    };

    clearIndicators = () => {
        this.indicatorComponent && this.indicatorComponent.clearIndicators();
    };

    render() {
        return <>
            {this.props.tradelaneData.gamePlayerId &&
                <TheRiverIndicator
                    tradelaneIndex={this.props.tradelaneIndex}
                    ref={this.setIndicatorRef}
                    tradelaneData={this.props.tradelaneData}
                    status={this.props.status}
                    inFlight={this.props.inFlight}
                    animate={this.props.animate}
                />
            }
            <TheRiverCard
                tradelaneIndex={this.tradelaneIndex}
                ref={this.setCardRef}
                updateCardIdComplete={this.updateCardIdComplete}
                onClick={this.onClick}
                tradelaneData={this.props.tradelaneData}
                status={this.props.status}
                animate={this.props.animate}
            />
        </>;
    }
}
